import { usePathname } from 'next/navigation'
import MenuItemButton from '../menuItemButton'
import HeaderGap from '@/components/atoms/headerGap'

const MenuItem = ({ onClick, hideEventsPage }) => {
  const pathname = usePathname()
  return (
    <div className="relative w-full grow overflow-y-scroll scrollbar-hidden px-smallMobile md:px-mediumDesktop">
      <HeaderGap />
      <div className="w-full max-w-[840px] mx-auto flex flex-wrap justify-center items-center gap-x-[84px] gap-y-[60px] mt-[100px] lg:mt-[80px] mb-[123px] lg:mb-largeDesktop">
        <MenuItemButton
          name="FACILITIES"
          link="/facilities"
          onClick={onClick}
          active={pathname === '/facilities'}
        />
        {!hideEventsPage && (
          <MenuItemButton
            name="EVENTS"
            link="/events"
            onClick={onClick}
            active={pathname === '/events'}
          />
        )}
        <MenuItemButton
          name="RETREAT"
          link="/retreat"
          onClick={onClick}
          active={pathname === '/retreat'}
        />
        <MenuItemButton
          name="ABOUT US"
          link="/about"
          onClick={onClick}
          active={pathname === '/about'}
        />
        <MenuItemButton
          name="CONTACT"
          link="/contact"
          onClick={onClick}
          active={pathname === '/contact'}
        />
      </div>
    </div>
  )
}

export default MenuItem
